import {
  isNotAssignedPickup,
  isNotCompletedPickup,
  isCompletedPickup,
  isMissedPickup,
  isFuturePickup,
  isTodaysPickup,
  isUnAcknowledgedPickup,
  isToBeReviewedPickup,
} from "../../../filterUtils";
const PICKUPS_GRID_FILTERS = {
  allPickups: "All",
  activePickups:"ActivePickups",
  notCompleted: "NotCompleted",
  unassigned: "Unassigned",
  future: "Future",
  unacknowledged: "Unacknowledged",
  missed: "Missed",
  completed: "Completed",
  voided: "Voided",
  noFreight: "No Freight",
  possibleMerge: "PossibleMerge",
  toBeReviewed: "To Be Reviewed"
};

const DEFAULT_DISPATCH_GRID_FILTER_LIST = [
  {
    label: 'All Pickups',
    value: PICKUPS_GRID_FILTERS.allPickups,
    filterFunc: ({ pickup, terminalOffset }) =>
      isMissedPickup({ pickup }) || isTodaysPickup(pickup.pickupDate, terminalOffset),
    showAssignedUnassignedRecommendations: true,
  },
  {
    label: 'Active Pickups',
    title: 'Not Completed + Unassigned',
    value: PICKUPS_GRID_FILTERS.activePickups,
    filterFunc: ({ pickup, terminalOffset }) =>
      isNotAssignedPickup({ pickup, terminalOffset }) ||
      isNotCompletedPickup({ pickup, terminalOffset }),
    showAssignedUnassignedRecommendations: true,
  },
  {
    label: "Unassigned",
    value: PICKUPS_GRID_FILTERS.unassigned,
    filterFunc: ({pickup, terminalOffset}) =>
      (isNotAssignedPickup({pickup, terminalOffset}) || isMissedPickup({pickup})) && !pickup.isToBeReviewed,
    showAssignedUnassignedRecommendations: false,
  },
  {
    label: "Not Completed",
    value: PICKUPS_GRID_FILTERS.notCompleted,
    filterFunc: ({pickup, terminalOffset}) => isNotCompletedPickup({pickup, terminalOffset}),
    showAssignedUnassignedRecommendations: true,
  },
  {
    label: "Future",
    value: PICKUPS_GRID_FILTERS.future,
    filterFunc: ({pickup, terminalOffset}) =>
      isFuturePickup(pickup.pickupDate, terminalOffset) && !pickup.isVoided,
  },
  {
    label: "Unacknowledged",
    value: PICKUPS_GRID_FILTERS.unacknowledged,
    filterFunc: ({pickup, terminalOffset}) => isUnAcknowledgedPickup({pickup, terminalOffset}),
  },
  {
    label: "Missed",
    value: PICKUPS_GRID_FILTERS.missed,
    filterFunc: ({pickup}) => isMissedPickup({pickup}),
  },
  {
    label: "Completed",
    value: PICKUPS_GRID_FILTERS.completed,
    filterFunc: ({pickup, terminalOffset}) => isCompletedPickup({pickup, terminalOffset}),
  },
  {
    label: "Voided",
    value: PICKUPS_GRID_FILTERS.voided,
    filterFunc: ({pickup}) => pickup.isVoided,
  },
  {
    label: "No Freight",
    value: PICKUPS_GRID_FILTERS.noFreight,
    filterFunc: ({pickup}) => pickup.isNoFreight,
  },
  {
    label: "Possible Merge",
    value: PICKUPS_GRID_FILTERS.possibleMerge,
    filterFunc: ({duplicatePickups}) => {
      return Boolean(duplicatePickups?.length)
    }
  },
  {
    label: "To be Reviewed",
    value: PICKUPS_GRID_FILTERS.toBeReviewed,
    filterFunc: ({pickup}) => isToBeReviewedPickup({pickup}),
  },
];

export { DEFAULT_DISPATCH_GRID_FILTER_LIST, PICKUPS_GRID_FILTERS };
